/*@ngInject*/
const FormViewerUtil = function (localization, dateUtil, formTemplateType) {

        this.findPrecedingFieldRowForSupplementalForm = function (precedingFieldVariableName, precedingFormTemplateUniqueName, sectionList) {
        let precedingFieldInfo;

        function searchSections(sectionList) {
            _.each(sectionList, function (section) {
                    return searchRows(section.rowList, section, precedingFormTemplateUniqueName);
            });
        }

            function searchRows(rowList, section, precedingFormTemplateUniqueName) {
            _.each(rowList, function (row, index) {
                let isRepeatingRow = !_.isNil(row.rowList);
                    if (section.parentUiFormTemplate.formTemplate.uniqueName === precedingFormTemplateUniqueName) {
                        searchFields(row.fieldStructureList, index, section);
                        if (isRepeatingRow) {
                            _.each(row.rowList, function (row) {
                                searchFields(row.fieldStructureList, index, section);
                            });
                        }
                    }

                if (row.sectionList) {
                    searchSections(row.sectionList);
                }
            });
        }

        function searchFields(fieldStructureList, precedingFieldRowIndex, section) {
            _.each(fieldStructureList, function (fieldStructure) {

                if (fieldStructure.uiField.fieldTemplate.variableName === precedingFieldVariableName) {
                    precedingFieldInfo = {};
                    precedingFieldInfo.precedingFieldRow = section.rowList[precedingFieldRowIndex];
                    precedingFieldInfo.precedingFieldRowIndex = precedingFieldRowIndex;
                    precedingFieldInfo.precedingFieldSection = section;
                }
            });
        }

        searchSections(sectionList);

        return precedingFieldInfo;
    };

    this.findLastFieldInPreviousRowKey = function (previousRow) {
        let lastFieldInRow = previousRow.rowTemplate.fields[previousRow.rowTemplate.fields.length - 1],
            key = lastFieldInRow.fieldTemplate.id + '-' + previousRow.rowModel.id;
        return key;
    };

    this.isFormVisible = function (currentWizardStep, currentSubmission, formIndex) {
        if (currentWizardStep === 'createSubmission' &&
            currentSubmission.forms[formIndex].form.formTemplate.type !== formTemplateType.SUBMISSION) {
            return false;
        }
        return true;
    };
};

angular.module('umFormViewer')
    .service('formViewerUtil', FormViewerUtil);

